import {
    Action,
    ThunkAction,
    combineReducers,
    configureStore
} from "@reduxjs/toolkit";

import * as AppConfigStore from "./AppConfigStore";
import * as AuctionStore from "./AuctionStore";
import * as DebugStore from "./DebugStore";
import * as ParcelBidStore from "./ParcelBidStore";
import * as ParcelStore from "./ParcelStore";
import * as SentryStore from "./SentryStore";
import * as TimerStore from "./TimerStore";
import * as UserStore from "./UserStore";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "../api/apiSlice";
import connectionSlice from "../api/connectionSlice";

const rootReducer = combineReducers({
    appConfigStoreState: AppConfigStore.reducer,
    auctionStoreState: AuctionStore.reducer,
    debugStoreState: DebugStore.reducer,
    parcelBidStoreState: ParcelBidStore.reducer,
    parcelStoreState: ParcelStore.reducer,
    sentryStoreState: SentryStore.reducer,
    timerStoreState: TimerStore.reducer,
    userStoreState: UserStore.reducer,
    // New
    [apiSlice.reducerPath]: apiSlice.reducer,
    connectionStoreState: connectionSlice
});

export type IAppState = ReturnType<typeof rootReducer>;

export function setupStore(preloadedState?: Partial<IAppState>) {
    const store = configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware().concat(apiSlice.middleware)
    });

    setupListeners(store.dispatch);

    return store;
}

export const store = setupStore();

export type IAppStore = ReturnType<typeof setupStore>;
export type IAppDispatch = IAppStore["dispatch"];
export type IAppThunkAction<ThunkReturnType = unknown> = ThunkAction<
    ThunkReturnType,
    IAppState,
    void,
    Action
>;
